import * as moment from 'moment';
import { ItemType } from '../classes/item-type';

const TIMESTAMP_KEY = "timestamp";
const SEAT_PATHS_KEY = "seatpaths";
const SEATMAP_BACKGROUND_KEY = "seatmapBackground";
const SEAT_REQUEST_KEY = "SSv2_SeatRequest";

export function getStorageItemWhere(checkKey: (key: string) => boolean) {
    var key = getStorageItemKeyWhere(checkKey);
    if (key) {
        return localStorage.getItem(key);
    }
    return '';
}

export function getStorageItemKeyWhere(checkKey: (key: string) => boolean): string {
    var keys = getStorageItemKeysWhere(checkKey);
    return (keys.length > 0 ? keys[0] : '');
}

export function getStorageItemKeysWhere(checkKey: (key: string) => boolean): string[] {
    var matchingKeys = [];
    for (var i = 0; i < localStorage.length; i++) {
        let currentKey = localStorage.key(i);
        if (checkKey(currentKey)) {
            matchingKeys.push(currentKey);
        }
    }
    return matchingKeys;
}

export function clearStorageItemsWhere(checkKey: (key: string) => boolean) {
    var keysToRemove = getStorageItemKeysWhere(checkKey);
    keysToRemove.forEach(key => {
        localStorage.removeItem(key);
    });
}

function keyWithTimeStamp(key: string, timestamp: any) {
    return `${key},${TIMESTAMP_KEY}:${moment(timestamp).format('YYYY-MM-DD h:mm a')}`;
}

export function getStorageItem(subKey: string) {
    return getStorageItemWhere(key => key.indexOf(subKey) > -1);
}

export function setStorageItem(subKey: string, value: string, timestamp: any) {
    const key = keyWithTimeStamp(subKey, timestamp);
    localStorage.setItem(key, value)
}


// Seat Paths
export function getSeatPathsKey(seatmapId, brandId) {
    return `${SEAT_PATHS_KEY}:${seatmapId},${brandId}`;
}
export function saveSeatPaths(seatmapId, brandId, value: string, timestamp) {
    const key = getSeatPathsKey(seatmapId, brandId);
    setStorageItem(key, value, timestamp);
}
export function getSavedSeatPaths(seatmapId, brandId) {
    const subKey = getSeatPathsKey(seatmapId, brandId);
    return getStorageItemWhere(key => key.indexOf(subKey) >= 0);
}

// Seatmap Backgrounds
export function getSeatmapBackgroundKey(seatmapId) {
    return `${SEATMAP_BACKGROUND_KEY}:${seatmapId}`;
}

export function saveSeatmapBackground(seatmapId, value: string, timestamp) {
    const key = getSeatmapBackgroundKey(seatmapId);
    setStorageItem(key, value, timestamp);
}

export function getSavedSeatmapBackground(seatmapId) {
    const subKey = getSeatmapBackgroundKey(seatmapId);
    return getStorageItemWhere(key => key.indexOf(subKey) >= 0);
}

export function deleteSeatmapBackground(seatmapId) {
    const subKey = getSeatmapBackgroundKey(seatmapId);
    const fullKey = getStorageItemKeyWhere(key => key.indexOf(subKey) >= 0);
    if (fullKey) {
        localStorage.removeItem(fullKey);
    }
}


// Seat maps
export function removeOldestSeatMaps() {
    clearStorageItemsWhere(key => !isTimeStampKey(key) && isSeatMapKey(key));

    var keysWithTimestamps = getStorageItemKeysWhere(key => isTimeStampKey(key));

    try {
        const sortedKeysWithTimestamps = keysWithTimestamps.filter(s => s.indexOf(",") >= 0).sort((a, b) => getTimestampFromKey(a).diff(getTimestampFromKey(b)));
        if (sortedKeysWithTimestamps.length > 1) {
            localStorage.removeItem(sortedKeysWithTimestamps[0]);
        }
        if (sortedKeysWithTimestamps.length > 2) {
            localStorage.removeItem(sortedKeysWithTimestamps[1]);
        }
    } catch (ex) {
        console.debug('SEATMAP_LOCAL_STORAGE: Error removing keys ' + keysWithTimestamps);
    }
}

function isSeatMapKey(key: string) {
    return (key.indexOf(SEATMAP_BACKGROUND_KEY) >= 0 || key.indexOf(SEAT_PATHS_KEY) >= 0);
}

function isTimeStampKey(key: string) {
    return (key.indexOf(TIMESTAMP_KEY) >= 0);
}

function getTimestampFromKey(cacheKey: string): moment.Moment {
    return moment(cacheKey
        .split(",")
        .filter(s => s.indexOf(TIMESTAMP_KEY) > -1)[0]
        .split(":")[1]
    );
}

// Seat Requests
export function getSeatRequestKey(itemId: number, itemType: ItemType) {
    return `${SEAT_REQUEST_KEY}:${itemId.toString()}~${itemType}`;
}

export function saveSeatRequest(itemId: number, itemType: ItemType, value: string) {
    const key = getSeatRequestKey(itemId, itemType);
    localStorage.setItem(key, value);
}

export function getSavedSeatRequest(itemId: number, itemType: ItemType) {
    const key = getSeatRequestKey(itemId, itemType);
    return localStorage.getItem(key);
}

export function deleteSeatRequest(itemId: number, itemType: ItemType) {
    const key = getSeatRequestKey(itemId, itemType);
    localStorage.removeItem(key);
}

export function clearAllSeatRequests() {
    clearStorageItemsWhere(key => key.indexOf(SEAT_REQUEST_KEY) >= 0);
}